import { render, staticRenderFns } from "./SidebarItems.vue?vue&type=template&id=d81da74a&scoped=true&"
import script from "./SidebarItems.vue?vue&type=script&lang=js&"
export * from "./SidebarItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81da74a",
  null
  
)

export default component.exports